import { useState } from "react";
import { Link } from "react-router-dom";

import { AuthButton, AuthCard, AuthField, AuthLinkRow, AuthNotice } from "./AuthCard";
import { requestPasswordReset } from "@/api/passwordReset";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!email.trim()) return;
    setIsLoading(true);
    const result = await requestPasswordReset(email.trim());
    setMessage(result.message);
    setIsLoading(false);
  };

  return (
    <AuthCard title="Reset your password" subtitle="Enter your email and we'll send you a link to choose a new one.">
      {message ? (
        <AuthNotice tone="info">{message}</AuthNotice>
      ) : (
        <form onSubmit={handleSubmit} noValidate>
          <AuthField label="Email" type="email" placeholder="Email" autoComplete="email" value={email} onChange={setEmail} />
          <AuthButton busy={isLoading} busyLabel="Sending...">Send reset link</AuthButton>
        </form>
      )}
      <AuthLinkRow>
        <Link to="/login">Back to sign in</Link>
      </AuthLinkRow>
    </AuthCard>
  );
};

export default ForgotPassword;
